'use client';

import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes';

/**
 * Workaround for next-themes injecting a <script> tag that triggers a React 19 console error.
 * On the client, we set type="application/json" so React doesn't warn about it —
 * the script already executed during SSR.
 * @see https://github.com/pacocoursey/next-themes/issues/385
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const scriptProps =
    typeof window === 'undefined' ? undefined : ({ type: 'application/json' } as const);

  return (
    <NextThemesProvider scriptProps={scriptProps} {...props}>
      {children}
    </NextThemesProvider>
  );
}
